export interface IFileDto {
    fileId: number;
    fileName: string;
    uploadedOn: string | null;
    uploadedByName: string | null;
}
